export * from './delete-objekt.command.module';
export * from './component';
export * from './service';